import { isServer } from '@/helpers/Platform/Platform';
import { HgSupportedLanguage } from '@smg-real-estate/domus';

/**
 *  For specific enums for the values you need to pass for tracking check
 *  https://docs.google.com/spreadsheets/d/1f90_U41depIwExovFHg1ACFUL0C9m5QSey64OU6H1Do/edit#gid=310863332
 */

export enum EventLabel {
  TAB_NAVIGATION = 'tab_navigation',
  SIDEBAR = 'sidebar',
}

export enum GTMPageFeatureId {
  INITIAL_PAGE_LOAD = 'p000',
}

export enum GTMPageType {
  FRONTEND_TEMPLATE_PAGE = 'frontendTemplatePage',
  PROPERTY_VALUATION = 'propertyValuation',
}

export enum GTMPageSubType {
  LANDING_PAGE = 'landingPage',
}

export enum GTMServingSystem {}

export enum InteractionEvent {
  LOAD = 'load',
  GENERIC_INTERACTION = 'generic_interaction',
  VIRTUAL_PAGEVIEW = 'virtual_pageview',
  FOOTER_CLICK = 'footer_interaction',
  HEADER_CLICK = 'header_interaction',
  OPEN_MY_ACCOUNT = 'open_my_account',
}

export enum InteractionContainerDetail {}

export enum InteractionGoal {}

export enum InteractionContainerName {}

export enum InteractionElement {}

export type TrackingParameterValue =
  | string
  | number
  | undefined
  | boolean
  | InteractionContainerDetail
  | InteractionEvent
  | InteractionGoal
  | InteractionContainerName
  | InteractionElement;

export interface GTMPageViewTrackingParameters {
  page_type: GTMPageType;
  tech_featureId: GTMPageFeatureId;
  page_contentLanguage: HgSupportedLanguage;
  page_normalizedUrl?: string;
  page_realUrl: string;
  [additionalParameters: string]: any;
}

export interface TrackingData {
  eventAction: string;
  eventLabel: string;
  contentLanguage?: string;
}

export function getBasicPageViewTrackingContext(
  pageType: GTMPageType,
  language: HgSupportedLanguage,
  fullRoutePath: string,
  normalizedFullRoutePath: string | null,
): {
  tech_release: string;
  page_realUrl: string;
  tech_featureId: GTMPageFeatureId;
  page_type: GTMPageType;
  tech_env: string;
  page_contentLanguage: HgSupportedLanguage;
} {
  return {
    tech_featureId: GTMPageFeatureId.INITIAL_PAGE_LOAD,
    page_type: pageType,
    page_contentLanguage: language,
    page_realUrl: `${import.meta.env.VUE_APP_BASE_URL}${fullRoutePath}`,
    ...(normalizedFullRoutePath !== null && {
      page_normalizedUrl: `${import.meta.env.VUE_APP_BASE_URL}${normalizedFullRoutePath}`,
    }),
    tech_release: `6_${import.meta.env.VUE_COMMIT_SHA}`,
    tech_env: import.meta.env.VUE_APP_STAGE,
  };
}

export function isGTMEnabled(): boolean {
  return !isServer();
}
export function trackEvent(
  eventName: string,
  eventParams: Record<string, TrackingParameterValue> = {},
): void {
  if (!isGTMEnabled()) {
    return;
  }

  const eventData = {
    event: eventName,
    ...eventParams,
  };

  window.dataLayer?.push(eventData);
  notifyParentWindow(eventData);
}

function notifyParentWindow(eventData: Record<string, any>): void {
  if ('parentIFrame' in globalThis) {
    globalThis.parentIFrame.sendMessage({
      type: 'gtm_tracking',
      data: eventData,
    });
  }
}

export function trackVirtualPageView(
  pageViewTrackingParameters: GTMPageViewTrackingParameters,
  eventParams: Record<string, TrackingParameterValue> = {},
): void {
  trackEvent(InteractionEvent.LOAD, {
    ...eventParams,
    ...pageViewTrackingParameters,
  });
}
